import { ReactNode, useState } from 'react'
import { Button, ButtonProps, ComponentTrackingType } from '@homebotapp/hb-react-component-catalog'
import { ClientEventSource } from '../../api/gqlaxy/gql/generated/graphql'
import { LeavingHomebotModal } from '../shared/LeavingHomebotCta/LeavingHomebotModal'

interface ScheduleACallButtonProps extends ButtonProps {
  dataQa?: string
  ctaLinkUrl?: string
  className?: string
  tracking: ComponentTrackingType
  renderModalBody?: () => ReactNode
  headerText?: string
  hideIllustration?: boolean
  scheduleACall?: boolean
  eventSource?: ClientEventSource
  children: ReactNode & Omit<ReactNode, 'null' | 'undefined'> // the intl'd button text
}

export const ScheduleACallButton = ({
  dataQa,
  ctaLinkUrl,
  className,
  headerText,
  renderModalBody,
  hideIllustration,
  scheduleACall,
  tracking,
  eventSource,
  children,
  ...restProps
}: ScheduleACallButtonProps) => {
  const [isCtaModalOpen, setIsCtaModalOpen] = useState(false)

  if (!ctaLinkUrl) {
    return null
  }

  return (
    <>
      <Button
        data-qa={dataQa}
        onClick={() => setIsCtaModalOpen(true)}
        tracking={{
          guid: '64tkcTW2MSf73C1YMhLZde',
          ui_context: tracking?.ui_context,
          descriptor: 'Schedule a call button clicked'
        }}
        {...restProps}
      >
        {children}
      </Button>
      <LeavingHomebotModal
        isOpen={isCtaModalOpen}
        renderModalBody={renderModalBody}
        renderModalHeaderText={headerText}
        handleClose={() => setIsCtaModalOpen(false)}
        hideIllustration={hideIllustration}
        scheduleACall={scheduleACall}
        ctaLinkUrl={ctaLinkUrl}
        tracking={tracking}
        eventSource={eventSource}
      />
    </>
  )
}
